export const GET_SETTINGS = 'GET_SETTINGS'
export const GET_SETTINGS_EXITO = 'GET_SETTINGS_EXITO'
export const GET_SETTINGS_ERROR = 'GET_SETTINGS_ERROR'
export const RESET_SETTINGS_BY_TYPE = 'RESET_SETTINGS_BY_TYPE'
